import { SKILL_TYPE_MANY } from "../../schema/skillType";
import React, { useState } from "react";
import Avatar from "../employees/Avatar";


import { useParams, Link } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { EMPLOYEE_MANY } from "../../schema/employee";
import { Competence, Employee } from "../../types";

const Match: React.FC = () => {
  const [skillTypeFilter, setSkillTypeFilter] = useState("");
  const { data: skillTypesData, loading: skillTypesLoading, error: skillTypesError } = useQuery(SKILL_TYPE_MANY);
  const { id } = useParams<{ id: string }>();
  const { data, loading, error } = useQuery(EMPLOYEE_MANY);

  if (loading) return <div>Loading...</div>;
  if (skillTypesLoading) return <div>Loading...</div>;
  if (error || skillTypesError) return <div>Error loading data.</div>;
  if (error) return <div>Error loading employees.</div>;

  const employees: Employee[] = data?.employeeMany || [];
  const selectedEmployee = employees.find(e => e._id === id);

  function getSimilarity(a: Employee, b: Employee): number {
    if (!a.competences || !b.competences) return 0;
    const filterByType = (comps: Competence[]) =>
      skillTypeFilter
        ? comps.filter(c => c.skill?.skillType?._id === skillTypeFilter)
        : comps;
    const aSkills = new Map(filterByType(a.competences).map((c: Competence) => [c.skillId, c.value]));
    const bSkills = new Map(filterByType(b.competences).map((c: Competence) => [c.skillId, c.value]));
    let common = 0;
    let total = 0;
    aSkills.forEach((aValue, skillId) => {
      if (bSkills.has(skillId)) {
        const bValue = bSkills.get(skillId);
        if (typeof bValue === "number") {
          common += 1 - Math.abs(aValue - bValue) / 100;
        }
      }
      total++;
    });
    return total > 0 ? common / total : 0;
  }

  const similarEmployees = selectedEmployee
    ? employees
        .filter(e => e._id !== id)
        .map(e => ({ ...e, similarity: getSimilarity(selectedEmployee, e) }))
        .sort((a, b) => b.similarity - a.similarity)
        .slice(0, 8)
    : [];

  return (
  <div className="pb-6">
      <div className="inline-flex items-center text-sm text-gray-500 leading-none pb-2">
        <span>Ähnliche Mitarbeiter</span>
      </div>
      <div className="flex items-center">
        <h1 className="px-2 text-2xl text-gray-900 font-extrabold">
          {selectedEmployee?.firstName} {selectedEmployee?.lastName}
        </h1>
      </div>
      <div className="mb-4">
        <label htmlFor="type" className="block text-sm font-medium text-gray-700">Kompetenztyp filtern</label>
        <select
          id="type"
          autoComplete="type"
          value={skillTypeFilter}
          onChange={e => setSkillTypeFilter(e.target.value)}
          className="mt-1 focus:ring-orange-500 focus:border-orange-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
        >
          <option value="">Alle</option>
          {skillTypesData?.skillTypeMany?.map((skillType: any) => (
            <option key={skillType._id} value={skillType._id}>{skillType.name}</option>
          ))}
        </select>
      </div>
      <h2 className="text-gray-500 text-xs font-medium uppercase tracking-wide">
        {`${similarEmployees.length} Ergebnisse`}
      </h2>
      <ul className="mt-3 grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {similarEmployees.map((e) => (
          <li key={e._id} className="col-span-1 bg-white rounded-xl shadow border-2 border-gray-300 flex flex-col items-center px-4 py-4">
            <Avatar employee={e} className="w-20 h-20 rounded-full border-4 border-orange-200 shadow mb-2" />
            <h3 className="text-lg font-semibold text-gray-900 mb-2 text-center">{e.firstName} {e.lastName}</h3>
            <div className="w-full mb-2 text-center">
              <span className="text-xl font-bold text-blue-700">{Math.round(e.similarity * 100)}%</span>
            </div>
            <div className="w-full border-t border-gray-200 pt-2 mt-2 flex gap-2 justify-center">
              <Link
                to={`/employees/${e._id}/details`}
                className="flex-1 py-1 px-2 text-sm text-orange-700 font-medium rounded-lg border border-orange-200 hover:bg-orange-50 transition text-center"
              >
                Details
              </Link>
              <Link
                to={`/employees/${e._id}/profile`}
                className="flex-1 py-1 px-2 text-sm text-orange-700 font-medium rounded-lg border border-orange-200 hover:bg-orange-50 transition text-center"
              >
                Profil
              </Link>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Match;
